import { i18n } from '@/locale/i18n'

// saves entire data locally (Projects with contacts and slabs with loads and openings)
// called each afterCreate, afterUpdate, afterDelete hook of projects, contacts, slabs, loads and openings modules
function syncToLocal (context) {
  const lsKey = context.rootState.lsKey

  const data = context.getters['projects/query']()
    .with('contacts')
    .with('slabs.*')
    .all()

  // can fail if user privacy mode doesnt allow localStorage
  try {
    localStorage.setItem(lsKey, JSON.stringify(data))
  } catch (err) {
  }
}

// generates new project & element
function createNewProject (getters) {
  const uuid = require('uuid-random')

  const newProjectID = uuid()
  const selected = uuid()

  const opcoId = getters.opcoId

  const products = getters.opcoProductTypes(opcoId)
  const productId = Object.keys(products)[0]
  const product = products[productId]
  const thickness = Object.keys(product.thickness)[0]

  let projects = {
    id: newProjectID,
    name: `${i18n.t('project')} 1`,
    opco_id: opcoId,
    slabs: [{
      id: selected,
      project_id: newProjectID,
      name: `${i18n.t('slab')} 1`,
      floor_product_type_id: productId,
      floor_thickness: thickness,
      floor_width: product.thickness[thickness][0].width,
      topping_thickness: product.thickness[thickness][0].topping_thickness[0]
    }]
  }

  return {
    projects,
    selected
  }
}

export { syncToLocal, createNewProject }



// WEBPACK FOOTER //
// ./src/store/mixins.js